import React from 'react';
import PropTypes from 'prop-types';
import DealsOverviewTable from '../shared//DealsOverviewTable';
import enhance from './InfluencerDashboard.enhancer';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VideocamIcon from '@material-ui/icons/Videocam';
import PaymentIcon from '@material-ui/icons/Payment';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import ItemsCarousel from 'react-items-carousel';
import LinkText from '../../shared/components/LinkText';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class InfluencerDashboard extends React.Component {
  constructor() {
    super();

    this.initialState = {
      activeStep: 0,
      isPaymentEntryModalOpen: false,
      influencerInfo: {
        description: '',
        audience: ''
      },
      currentActiveCompany: 0,
      currentActiveYoutubeVideo: 0,
      numberOfVideoCards: this.currentWidthVideos(),
      numberOfInfluencerCards: this.currentWidthInfluencers()
    };

    this.state = {
      ...this.initialState
    };
  }

  componentDidMount() {
    // load relevant campaigns
    if (!this.props.relevantCampaigns || !this.props.relevantCampaigns.length) {
      this.props.loadRelevantCampaignsHandler(this.props.auth.uid);
    }

    window.addEventListener(
      'resize',
      () => {
        const numberOfVideoCards = this.currentWidthVideos();
        if (this.state.numberOfVideoCards !== numberOfVideoCards) {
          this.setState({
            numberOfVideoCards
          });
        }
      },
      false
    );
    window.addEventListener(
      'resize',
      () => {
        const numberOfInfluencerCards = this.currentWidthInfluencers();
        if (this.state.numberOfInfluencerCards !== numberOfInfluencerCards) {
          this.setState({
            numberOfInfluencerCards
          });
        }
      },
      false
    );
  }

  getInterests(influencer) {
    if (!influencer.interests || !influencer.interests.length) {
      return [];
    }

    return influencer.interests.slice(0, 3);
  }

  currentWidthVideos() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 1100) numberOfCards = 2;
    else if (window.innerWidth < 1500) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  currentWidthInfluencers() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 800) numberOfCards = 2;
    else if (window.innerWidth < 1280) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  handleInterestButtonClick(campaign) {
    if (
      this.props.profile.paypalInfo &&
      this.props.profile.paypalInfo.payerId
    ) {
      const influencerId = this.props.auth.uid;
      const companyId = campaign.creator;
      const campaignId = campaign.id;

      if (influencerId && companyId && campaignId) {
        this.props.interestedClickHandler(influencerId, companyId, campaignId);
      }
    } else {
      this.setState({
        isPaymentEntryModalOpen: true
      });
    }
  }

  navigateToSettings() {
    this.props.history.push(`/settings`);
  }

  handleClosePaymentModal() {
    this.setState({
      isPaymentEntryModalOpen: false
    });
  }

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToProfile(userId) {
    this.props.history.push(`user/${userId}/profile`);
  }

  setActiveCompany = value => {
    this.setState({
      ...this.state,
      currentActiveCompany: value
    });
  };

  setActiveYoutubeVideo = value => {
    this.setState({
      ...this.state,
      currentActiveYoutubeVideo: value
    });
  };

  render() {
    const {
      classes,
      auth,
      profile,
      dealList,
      activeDealsCount,
      pendingDealAccepted,
      pendingMatchesCount,
      completedDealsCount,
      relevantCampaigns,
      currentActiveYoutubeVideo
    } = this.props;
    const {
      currentActiveCompany,
      numberOfVideoCards,
      numberOfInfluencerCards
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.dashboardContainer}>
          <Typography variant="h3" id="tableTitle" className={classes.title}>
            Influencer Dashboard
          </Typography>
          <Grid container direction="column" spacing={6}>
            <Grid container item spacing={4} xs={12}>
              <Grid item sm={3} xs={12}>
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <IconButton color="primary" className={classes.cardIcon}>
                      <AssignmentTurnedInIcon />
                    </IconButton>
                    <Typography variant="h4">{activeDealsCount}</Typography>
                    <div>Active Deals</div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <IconButton color="primary" className={classes.cardIcon}>
                      <VideocamIcon />
                    </IconButton>
                    <Typography variant="h4">{pendingDealAccepted}</Typography>
                    <div>Deals Waiting for Review</div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <IconButton color="primary" className={classes.cardIcon}>
                      <PersonIcon />
                    </IconButton>
                    <Typography variant="h4">{pendingMatchesCount}</Typography>
                    <div>Pending matches</div>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <IconButton color="primary" className={classes.cardIcon}>
                      <PaymentIcon />
                    </IconButton>
                    <Typography variant="h4">{completedDealsCount}</Typography>
                    <div>Completed Deals</div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <DealsOverviewTable dealList={dealList} forCompany={false} />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.subTitle} variant="h5">
                Your Activity
              </Typography>
              <div style={{ width: '95%' }}>
                {profile.youtube &&
                  profile.youtube.last5Uploads &&
                  profile.youtube.last5Uploads.length && (
                    <ItemsCarousel
                      gutter={12}
                      activePosition={'center'}
                      chevronWidth={40}
                      numberOfCards={numberOfVideoCards}
                      outsideChevron={true}
                      showSlither={false}
                      firstAndLastGutter={false}
                      activeItemIndex={currentActiveYoutubeVideo}
                      requestToChangeActive={this.setActiveYoutubeVideo.bind(
                        this
                      )}
                      rightChevron={<ChevronRightIcon />}
                      leftChevron={<ChevronLeftIcon />}
                    >
                      {profile.youtube.last5Uploads.map(upload => (
                        <div
                          key={upload.contentDetails.videoId}
                          className={classes.youtubeVideoUpload}
                        >
                          <iframe
                            className={classes.iframeContainer}
                            src={`https://www.youtube.com/embed/${upload.contentDetails.videoId}`}
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          />
                        </div>
                      ))}
                    </ItemsCarousel>
                  )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography
                className={classes.subTitle}
                variant="h5"
                id="tableTitle"
              >
                Suggested Campaigns
              </Typography>
              <Grid container direction="row">
                {relevantCampaigns && relevantCampaigns.length > 0 && (
                  <div style={{ width: '95%' }}>
                    <ItemsCarousel
                      gutter={12}
                      activePosition={'center'}
                      chevronWidth={40}
                      numberOfCards={numberOfInfluencerCards}
                      outsideChevron={true}
                      showSlither={false}
                      firstAndLastGutter={false}
                      activeItemIndex={currentActiveCompany}
                      requestToChangeActive={this.setActiveCompany.bind(this)}
                      rightChevron={<ChevronRightIcon />}
                      leftChevron={<ChevronLeftIcon />}
                    >
                      {relevantCampaigns.map((campaign, i) => (
                        <Paper className={classes.carousel}>
                          <Card key={i} className={classes.suggestCard}>
                            <CardHeader
                              title={
                                <Grid
                                  container
                                  justify="space-between"
                                  spacing={1}
                                  className={classes.interestsHeader}
                                >
                                  {this.getInterests(campaign.company)
                                    .slice(0, 3)
                                    .map(interest => {
                                      return (
                                        <Typography display="inline">
                                          {interest}
                                        </Typography>
                                      );
                                    })}
                                  {this.getInterests(campaign.company).length >
                                  3 ? (
                                    <Grid item>
                                      <Typography>...</Typography>
                                    </Grid>
                                  ) : (
                                    ''
                                  )}
                                </Grid>
                              }
                              className={classes.suggestCardHeader}
                            />
                            <CardContent className={classes.suggestCardContent}>
                              <Grid container direction="column">
                                <Grid item xs={12} align="center">
                                  <div className={classes.profilePicture}>
                                    <img
                                      src={campaign.company.profilePictureUrl}
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={12} align="center">
                                  <LinkText
                                    noWrap
                                    variant="h5"
                                    onClick={() =>
                                      this.navigateToCampaign(campaign.id)
                                    }
                                  >
                                    {campaign.name}
                                  </LinkText>
                                  <LinkText
                                    noWrap
                                    variant="body1"
                                    onClick={() =>
                                      this.navigateToProfile(
                                        campaign.company.id
                                      )
                                    }
                                  >
                                    {campaign.company.displayName}
                                  </LinkText>
                                </Grid>
                              </Grid>
                            </CardContent>
                            <CardActions className={classes.suggestCardActions}>
                              <Grid
                                container
                                item
                                className={`${
                                  campaign.matchRequested
                                    ? classes.influencerListBottomMatchRequested
                                    : classes.influencerListBottomNotMatched
                                }`}
                                align="center"
                                onClick={() =>
                                  this.navigateToCampaign(campaign.id)
                                }
                              >
                                <Typography className={classes.requestText}>
                                  View Details
                                </Typography>
                              </Grid>
                            </CardActions>
                          </Card>
                        </Paper>
                      ))}
                    </ItemsCarousel>
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </main>
        <Dialog
          id="payment-info-dialog"
          open={this.state.isPaymentEntryModalOpen}
          onClose={this.props.handleClose}
          disableAutoFocus={true}
          onBackdropClick={this.handleClosePaymentModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              maxWigth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="h6" align="center" justify="center">
            Set up your payment info before sending your interest to a campaign!
          </Typography>
          <Typography variant="body1" align="center" justify="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.paymentButton}
              onClick={this.navigateToSettings.bind(this)}
            >
              Payment Settings
            </Button>
          </Typography>
        </Dialog>
      </React.Fragment>
    );
  }
}

InfluencerDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object,
  profile: PropTypes.object,
  router: PropTypes.object
};

export default enhance(InfluencerDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/influencer/InfluencerDashboard.js